import {GridComparatorFn, GridSortDirection} from '@mui/x-data-grid';

export const nameGetSortComparator = (sortDirection: GridSortDirection): GridComparatorFn => (
   v1: string,
   v2: string,
   cell1,
   cell2
) => {
   console.debug('name sort', v1, v2, cell1, cell2);
   console.debug('val', cell1.api.getRow(cell1.id));

   const a = cell1.api.getRow(cell1.id);
   const b = cell2.api.getRow(cell2.id);

   const aIsFolder = a.type === 'folder';
   const bIsFolder = b.type === 'folder';
   const isDesc = sortDirection === 'desc';

   // folders first
   if (aIsFolder !== bIsFolder) {
      return aIsFolder && isDesc ? -1 : 1;
   }

   const result = v1.localeCompare(v2, undefined, {
      sensitivity: 'base',
   });

   return isDesc ? result : -result;
};

export const dateGetSortComparator = (sortDirection: GridSortDirection): GridComparatorFn => (
   v1: string,
   v2: string,
   cell1: any,
   cell2: any
) => {
   console.debug('date sort', v1, v2, cell1, cell2);
   const a = cell1.api.getRow(cell1.id);
   const b = cell2.api.getRow(cell2.id);

   const aIsFolder = a.type === 'folder';
   const bIsFolder = b.type === 'folder';
   const isDesc = sortDirection === 'desc';

   // folders first
   if (aIsFolder !== bIsFolder) {
      return aIsFolder && isDesc ? -1 : 1;
   }

   const t1 = v1 ? new Date(v1).getTime() : 0;
   const t2 = v2 ? new Date(v2).getTime() : 0;

   const result = t1 - t2;

   return isDesc ? result : -result;
};

export const numberGetComparator = (sortDirection: GridSortDirection): GridComparatorFn => (
   v1: string,
   v2: string,
   cell1,
   cell2
) => {
   console.debug('number sort', v1, v2, cell1, cell2);
   const a = cell1.api.getRow(cell1.id);
   const b = cell2.api.getRow(cell2.id);

   const aIsFolder = a.type === 'folder';
   const bIsFolder = b.type === 'folder';
   const isDesc = sortDirection === 'desc';

   // folders first
   if (aIsFolder !== bIsFolder) {
      return aIsFolder && isDesc ? -1 : 1;
   }

   const result = Number(v1) - Number(v2);

   return isDesc ? result : -result;
};
